import { useEffect } from 'react';
import {
  Col,
  Row,
  List,
  Utils,
  mapQuery,
  AddButton,
  FlexLayout,
  ListHeader,
  useNavigate,
  EllipsisText,
  useElementSize,
  ListHeaderWrap,
  useSearchPagination,
} from '@gv/triage-components';

import { CallTab } from 'types';
import { useBitwerxListQuery } from 'store/api/clients';

import * as Styles from '../styles';
import { ClientListProps, SelectClientFormValues } from '../types';
export * from '../config';
export type { SelectClientFormValues };

import { Routes } from 'config';
const { textValue, formatPhone } = Utils.Helpers;

export const BitwerxClientList = ({
  formik,
  backTitle,
  hospitalId,
  newClientPath,
  template = '19% 19% 14% 1fr 1fr',
}: ClientListProps) => {
  const pageData = useSearchPagination();
  const navigate = useNavigate();
  const { errors, values, resetForm, setFieldValue } = formik;
  const basePath = `${Routes.ActionCenter.Comm}/${CallTab.Consultation}`;
  const [listWrapperRef, { width }] = useElementSize();

  const { currentPage: page, debounceQuery: search } = pageData;
  const { data, ...props } = useBitwerxListQuery({
    page,
    search,
    hospitalId: String(hospitalId),
  });

  const { selectedBitwerxClientId } = values;

  useEffect(() => {
    if (
      selectedBitwerxClientId &&
      !data?.rows.some((client: any) => client.id === selectedBitwerxClientId)
    ) {
      resetForm();
    }
  }, [data, selectedBitwerxClientId, resetForm]);
  return (
    <List
      {...mapQuery(props)}
      count={data?.count}
      listWrapperRef={listWrapperRef}
      searchContainerStyle={{
        marginTop: 0,
      }}
      topHeader={
        <Styles.ListHeader>
          <Styles.BackButton text={backTitle} />
          <AddButton text="New client" to={newClientPath} />
        </Styles.ListHeader>
      }
      header={
        <ListHeaderWrap>
          {(scrollProps) => (
            <>
              {errors.selectedBitwerxClientId && (
                <Styles.Error>
                  {errors.selectedBitwerxClientId as string}
                </Styles.Error>
              )}

              {width > 800 && (
                <ListHeader
                  template={template}
                  titles={[
                    'Client',
                    'Phone',
                    'Pet',
                    'Address',
                    'View PIMS Details',
                  ]}
                  {...scrollProps}
                />
              )}
            </>
          )}
        </ListHeaderWrap>
      }
      {...pageData}
    >
      {data?.rows?.map((client: any) => {
        const { id, phones, addresses, firstName, clientPatientRelationships } =
          client;

        const formattedPhone = formatPhone(phones[0]?.number);

        const commonProps = {
          key: id,
          onClick: () => {
            setFieldValue('selectedBitwerxClientId', id);
          },
          selected: selectedBitwerxClientId
            ? id === selectedBitwerxClientId
            : false,
        };

        return width > 800 ? (
          <Styles.ListCard
            gap={24}
            template={template}
            values={[
              <Styles.Name className="semibold">{firstName}</Styles.Name>,
              formattedPhone,
              clientPatientRelationships[0]?.patient?.name,
              addresses?.[0]?.address1,
              <span
                style={{
                  color: 'blue',
                }}
                onClick={() => {
                  navigate(
                    `${basePath}${Routes.ActionCenter.InComm.BitwerxDetail}`.replace(
                      ':clientId',
                      id + ''
                    )
                  );
                }}
              >
                Click Here
              </span>,
            ]}
            {...commonProps}
          />
        ) : (
          <Styles.Client {...commonProps}>
            <Styles.Name>{firstName}</Styles.Name>
            <Row>
              <Col col={6}>
                <FlexLayout flexDirection="column">
                  <Styles.Label>Phone</Styles.Label>
                  <EllipsisText>{formattedPhone}</EllipsisText>
                </FlexLayout>
              </Col>
              <Col col={6}>
                <FlexLayout flexDirection="column">
                  <Styles.Label>Pet</Styles.Label>
                  <EllipsisText>
                    {textValue(clientPatientRelationships[0]?.patient?.name)}
                  </EllipsisText>
                </FlexLayout>
              </Col>
            </Row>
            <Row>
              <Col>
                <FlexLayout flexDirection="column">
                  <Styles.Label>Address</Styles.Label>
                  <EllipsisText>
                    {textValue(addresses?.[0]?.address1)}
                  </EllipsisText>
                </FlexLayout>
              </Col>
            </Row>
            <Row>
              <Col>
                <FlexLayout flexDirection="column">
                  <Styles.Label>PIMS Detail</Styles.Label>
                  <EllipsisText>
                    {textValue(addresses?.[0]?.address1)}
                  </EllipsisText>
                </FlexLayout>
              </Col>
            </Row>
          </Styles.Client>
        );
      })}
    </List>
  );
};
